module.exports = __webpack_public_path__ + "files/SPIADI2026 - OBSERVA4 - Fiche P2 (Version 1).f92231124fac818b099bb25539d5343e.pdf";